import { browserName, fullBrowserVersion } from 'react-device-detect';

export const getDeviceName = (): string => `${browserName} ${fullBrowserVersion}`;
